import { render } from "./AdminStats.vue?vue&type=template&id=2a39893c&scoped=true"
import script from "./AdminStats.vue?vue&type=script&lang=js"
export * from "./AdminStats.vue?vue&type=script&lang=js"

import "./AdminStats.vue?vue&type=style&index=0&id=2a39893c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a39893c"]])

export default __exports__